import { FC, PropsWithChildren, createContext, useContext, useState } from "react";
import { FreezerItem, PoolFragmentFragment } from "../../gql/generated/stats2.sdk";

export enum EActiveLiquidityDialog {
  provideLiquidity = "provideLiquidity",
  withdrawLiquidity = "withdrawLiquidity",
  lockLiquidity = "lockLiquidity",
  unlockLiquidity = "unlockLiquidity",
  harvest = "harvest",
  trade = "trade",
}
export interface ILiquidityContext {
  activeLiquidityDialog: EActiveLiquidityDialog;
  activePool: PoolFragmentFragment;
  activeYieldFarmingItem: FreezerItem;
  closeLiquidityDialog(): void;
  setActiveLiquidityDialog(activeLiquidityDialog: EActiveLiquidityDialog): void;
  setActivePool(activePool: PoolFragmentFragment): void;
  setActiveYieldFarmingItem(activeYieldFarmingItem: FreezerItem): void;
}

const defaultLiquidityState: ILiquidityContext = {
  activeLiquidityDialog: undefined,
  activePool: undefined,
  activeYieldFarmingItem: undefined,
  closeLiquidityDialog: () => {},
  setActiveLiquidityDialog: () => {},
  setActivePool: () => {},
  setActiveYieldFarmingItem: () => {},
};

const LiquidityContext = createContext(defaultLiquidityState);

export const useLiquidityContext = () => useContext(LiquidityContext);

export const LiquidityContextProvider: FC<PropsWithChildren> = ({ children }) => {
  const [activeLiquidityDialog, setActiveLiquidityDialog] = useState<EActiveLiquidityDialog>();
  const [activeYieldFarmingItem, setActiveYieldFarmingItem] = useState<FreezerItem>();
  const [activePool, setActivePool] = useState<PoolFragmentFragment>();
  const closeLiquidityDialog = () => setActiveLiquidityDialog(undefined);

  return (
    <LiquidityContext.Provider
      value={{
        activeLiquidityDialog,
        activePool,
        activeYieldFarmingItem,
        closeLiquidityDialog,
        setActiveLiquidityDialog,
        setActivePool,
        setActiveYieldFarmingItem,
      }}
    >
      {children}
    </LiquidityContext.Provider>
  );
};
